(function () {
  "use strict";

  angular.module("MktzapApp.Factories")
    .factory('PermissionControlService', PermissionControlService);

  function PermissionControlService($rootScope) {
    return {
      functions: {
        modules: function (permissionName) {
          if ($rootScope.user_data.modules.includes(permissionName)) return true;
          return false;
        },
        permissions: function (permissionName) {
          if ($rootScope.user_data.permissions.hasOwnProperty(permissionName)) return true;
          return false;
        }
      },

      checkAllowed: function (name) {
        var user = $rootScope.user_data;

        // If the user is a Lord, he has free access to everything
        if (user.role == $rootScope.profiles.ROLE_ADMIN) return true;

        // Verification of User Assigned Permission
        return this.hasPermission(name);
      },

      hasPermission: function (name) {
        name = name.split('.');

        if ($rootScope.user_data.permissions.hasOwnProperty('Lord')) {
          return true;
        }

        // Test action
        if (name.length == 3) {
          return $rootScope.user_data.permissions.hasOwnProperty(name[0]) && $rootScope.user_data.permissions[name[0]].hasOwnProperty(name[1]) && $rootScope.user_data.permissions[name[0]][name[1]].indexOf(name[2]) != -1;
        }

        // Test sub-module
        if (name.length == 2) {
          return $rootScope.user_data.permissions.hasOwnProperty(name[0]) && $rootScope.user_data.permissions[name[0]].hasOwnProperty(name[1]);
        }

        // Test module
        if (name.length == 1) {
          return !!$rootScope.user_data.permissions.hasOwnProperty(name[0]);
        }
      }

    }
  }

})();
